import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapFrom',
})
export class MapFromPipe implements PipeTransform {
  transform<T extends Record<PropertyKey, unknown>, K extends keyof T>(
    key: K,
    mapping: T
  ) {
    if (Object.prototype.hasOwnProperty.call(mapping, key)) {
      return mapping[key];
    }

    return key;
  }
}
